import { HttpClient } from "@angular/common/http";
import { ThisReceiver } from "@angular/compiler";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { CustomerDTO } from "../models/Customers/CustomerDTO";
import { CustomersService } from "./ServiceCatalogEncapsulators/Customers.service";
import { Subscription } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class SessionService {
  public isMapix: boolean = false;
  public Customer: CustomerDTO;
  private configUrl = "";

  subscription_GetCustomer: Subscription;

  constructor(
    private http: HttpClient,
    private CustomerService: CustomersService,
    private router: Router
    ) {
    this.configUrl = environment.host;
    this.CheckURLSource();
  }

 CheckURLSource() {
    try{
      var url = window.parent.location;
      if("mapix.einteligent.com" == url.host || "mapix.test.einteligent.com" == url.host || "mapix.dev.einteligent.com" == url.host || "mapixstage.test.einteligent.com" == url.host || "localhost:4200" == url.host || "mapixv2.einteligent.com" == url.host ){
        this.isMapix = true;
      }
    }catch(e){
      this.isMapix = false;
      console.log("ERROR TO READ HOST, CONTINUE WITHOUT RETURNS");
    }
  }

  getAPIversion() :any{
    console.log("/api/System/GetAPIVersion/");
    return this.http.get<string>(
      this.configUrl + "/api/System/GetAPIVersion");
  }

  getCustomerId(){
    if (this.subscription_GetCustomer && !this.subscription_GetCustomer.closed) {
      return;
    }
    this.subscription_GetCustomer = this.CustomerService.getRefererClient().subscribe(d=>{
      if(d.isSuccess==true){
        console.log("GET /api/Customer/GetbyClientId/ ", d);
        
        this.Customer = d.result;
        this.subscription_GetCustomer.unsubscribe();
      }
    });
  }

  

  ReloadPage(){
    var currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>{
      this.router.navigate([currentUrl]);
    });
  }
}
